<template>
  <div class="question" :style="{ height: screenHeight + 'px' }">
    <div class="container" v-if="questionData">
      <QuestionSteps
        class="steps-ponent"
        :data="questionData"
        @pre="bindPreQuestion"
        :theme="questionData.theme"
      />
      <div class="question-content">
        <div
          class="que-scroll"
          v-if="
            questionData.question &&
            questionData.question.length &&
            questionData.question[questionData.questionIndex]
          "
        >
          <QuestionItem
            :data="questionData.question[questionData.questionIndex]"
            @change="bindChange"
            :question="questionData.question"
            :theme="questionData.theme"
          />
        </div>
        <QuestionTips
          :data="questionData.question[questionData.questionIndex]"
        />
        <div class="btn-content">
          <div
            class="next-step"
            :style="{ background: questionData.theme.btnColor }"
            v-show="showNext"
            @click="bindNextQuestion"
            >下一题</div
          >
          <div
            class="confirm"
            v-show="questionData.finished"
            @click="bindConfirm"
            :style="{ background: questionData.theme.btnColor }"
            >提交问卷</div
          >
        </div>
      </div>
    </div>
    <AppLoading class="loading" v-if="!loaded" />
  </div>
</template>
<script>
import { Question } from './question.js'
import { isIOS } from '@/common/common.js'
import appApi from '@/common/app-common.js'
import QuestionSteps from './components/steps.vue'
import QuestionItem from './components/question-item.vue'
import AppLoading from '@/components/app/loading/loading'
import QuestionTips from './components/question-tips.vue'
import Cookies from 'js-cookie'
export default {
  components: {
    QuestionSteps,
    QuestionItem,
    AppLoading,
    QuestionTips
  },
  data() {
    return {
      loaded: false,
      questionData: null,
      screenHeight: 0,
      signToken: ''
    }
  },
  computed: {
    /* 是否显示下一题 */
    showNext() {
      if (this.questionData.canNext) {
        switch (
          this.questionData.question[this.questionData.questionIndex].que_type
        ) {
          case 0:
            let options =
              this.questionData.question[this.questionData.questionIndex]
                .options
            for (let item of options) {
              if (
                item.que_answer_attr &&
                item.key ===
                  this.questionData.question[this.questionData.questionIndex]
                    .value
              ) {
                return true
              }
            }
            return false
          case 7:
            return false
        }
      } else {
        return false
      }
      let showNext =
        this.questionData.canNext &&
        ![0, 7].includes(
          this.questionData.question[this.questionData.questionIndex].que_type
        )
      return showNext
    }
  },
  created() {
    this.setTitle()
    this.init()
    // this.getQuestionData();
  },
  mounted() {
    this.screenHeight = window.innerHeight
    /* 处理ios底部导航栏改变影响ui表现 */
    window.addEventListener('resize', () => {
      if (isIOS()) {
        this.screenHeight = window.innerHeight
      }
    })
  },
  methods: {
    setTitle() {
      this.$betterwe.initWebViewUIConfig({
        title: this.$route.query.title || '问卷',
        isTransparentBottomBar: 1
      })
    },
    bindChange(value) {
      this.questionData.change()
    },
    bindPreQuestion() {
      this.questionData.pre()
    },
    /* 下一题 */
    bindNextQuestion() {
      this.questionData.next()
    },
    //隐藏题目
    hideQuestion() {},
    //显示题目
    showQuestin() {},
    bindConfirm() {
      if (this.questionData.que_allow_num == 1) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '问卷结果一旦确认就无法修改，您是否已确认所有选项所填无误'
          })
          .then(() => {
            this.bindSubmit()
          })
          .catch(() => {
            // on cancel
          })
      } else {
        this.bindSubmit()
      }
    },
    bindSubmit() {
      if (this.isSubmit) {
        return
      }
      let res = this.questionData.getResult()
      let params = {
        token: this.token,
        accompany_phone: this.$route.query.accompany_phone || '',
        que_data: res
      }
      this.$http
        .postBaseAppWithHeader('que/QueCamp/saveCampQue', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.isSubmit = true
            this.$toast('提交成功')
            this.questionData.clearQuestion()
            this.$router.push('/join-camp-question-v2/submit')
          } else {
            this.$toast(res.msg)
          }
        })
    },
    async getQuestionData() {
      let params1 = {
        que_id: +this.$route.query.id || 0,
        que_from_id: +this.$route.query.fid || 0,
        token: this.token
      }
      let params2 = {
        sign_token: this.signToken
      }
      let promise1 = this.$http.getBaseApp(
        'que/QueCamp/getCampQueInfo',
        params1
      )
      let promise2 = this.$http.getApp('getWxUserInfo', params2)
      let res = await Promise.all([promise1, promise2]).catch(() => {})
      if (res) {
        let res1 = res[0].data
        let res2 = res[1].data
        if (res1.code == 200) {
          this.questionData = new Question(
            this.dealQuestionData(res1.data, res2.data)
          )
        }
      }
      this.loaded = true
    },
    dealQuestionData(data, wxInfo) {
      if (data.base_info) {
        data.base_info.wx_nickname = wxInfo?.nickname || ''
      }
      let step = 0
      data.question.map((item) => {
        if (item.que_type == 7) {
          item.step = step
          step++
        }
        if (item.que_filed == 'camp_que_from') {
          item.options[0].key = data.base_info.camp_info.id
          item.options[0].value = data.base_info.camp_info.name
          item.default_value = data.base_info.camp_info.id
        }
        let info = data.base_info[item.que_filed.slice(5)]
        if (info) {
          item.default_value = info
        }
        if (item.que_filed == 'camp_phone') {
          item.disabled = true
        }
      })
      return data
    },
    init() {
      this.signToken =
        this.$route.query.sign_token || localStorage.getItem('signToken') || ''
      if (this.$route.query.sign_token) {
        localStorage.setItem('signToken', this.$route.query.sign_token)
      }
      this.token = Cookies.get('join-camp-token')
      // 没有自带减脂营token则走减脂营授权拿token
      if (!this.signToken) {
        window.location.href = `https://btwx.gymcity.com.cn/wxAuth?auth=wegymer&scope=snsapi_userinfo&next=${encodeURIComponent(
          location.href
        )}`
      } else {
        /* 判断登录是否过期 */
        if (this.token) {
          this.getQuestionData()
        } else {
          this.$router.push('/join-camp-question-v2/login')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.question {
  transform: translateX(0);
  background-color: #fff;
  height: 100vh;
}

.loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}

.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  box-sizing: border-box;

  .steps-ponent {
    margin-bottom: 20px;
  }

  .question-content {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 0px 22px 0px;
    box-sizing: border-box;

    .que-scroll {
      width: 100%;
      flex: 1;
      flex-shrink: 0;
      overflow-y: scroll;
      position: relative;
    }

    .btn-content {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .next-step,
    .confirm {
      text-align: center;
      width: 188px;
      height: 50px;
      background: #524485;
      border-radius: 25px;
      font-size: 15px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      color: #ffffff;
      line-height: 50px;
      margin-bottom: 50px;
      margin-top: 16px;
    }

    .tips {
      margin-top: 12px;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(39, 36, 60, 0.5);
      line-height: 20px;

      .red {
        margin-right: 4px;
        color: rgba(255, 85, 119, 1);
      }
    }
  }
}
</style>
